(() => {
  if (customElements.get('load-more')) {
    return;
  }

  class LoadMore extends HTMLElement {
    constructor() {
      super();

      this.productsContainer = document.querySelector('#product-grid');
      this.button = this.querySelector('[data-button]');
    }

    connectedCallback() {
      this.attachEvents();
    }

    attachEvents() {
      this.button?.addEventListener('click', this.loadResults.bind(this));
    }

    loadResults(event) {
      event.preventDefault();

      this.classList.add('is-loading');

      const url = this.button.getAttribute('href');

      this.getResults(url);
    }

    getResults(url) {
      fetch(url)
        .then((response) => response.text())
        .then((responseText) => {
          const html = responseText;

          this.renderProductGridContainer(html);
          this.updateLoadMoreButton(html);

          this.classList.remove('is-loading');
        });
    }

    renderProductGridContainer(html) {
      this.productsContainer.innerHTML += new DOMParser()
        .parseFromString(html, 'text/html')
        .getElementById('product-grid').innerHTML;
    }

    updateLoadMoreButton(html) {
      this.loadMoreButton = new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector('load-more [data-button]');

      if (!this.loadMoreButton) {
        this.classList.add('hidden');

        return;
      }

      this.button.href = this.loadMoreButton.getAttribute('href');
    }
  }

  customElements.define('load-more', LoadMore);
})();
